import React, { Fragment } from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { submit } from 'redux-form';

import store from '../../store/redux_store';
import { getSelectedFabric, recalculateShirtPrice, getSelectedSize } from '../../selectors/entities/general';
import { isAddedToCart } from '../../selectors/entities/users';
import { getActiveDetailsPreset } from '../../selectors/entities/ui';
import { addToCart, closeCartWidget } from '../../actions/general';
import { setViewTab, screenResize, toggleSetParamsError } from "../../actions/ui";

import BuilderFabric from '../BuilderFabric';
import BuilderDetail from '../BuilderDetail';
import BuilderSize from '../BuilderSize';
import BuilderProduct from '../BuilderProduct';
import Widget from '../ProductWidget';
import CartErrorModal from '../CartErrorModal';
import RubleIcon from '../icons/RubleIcon';

class Builder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      widthWindow: window.innerWidth,
      page: 1,
      errorMessage: null,
      errorModalOpened: false,
    }
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    this.handleWindowSizeChange()
  }

  handleWindowSizeChange = () => {
    const { actions: { screenResize } } = this.props;
    store.dispatch(screenResize(window.innerWidth));
  };
  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  next = async () => {
    const { selectedTab, sizeActiveTab } = this.props;

    if(selectedTab === 2) {
      if (sizeActiveTab === 'smart' || sizeActiveTab === 'measure') {
        await store.dispatch(submit('measureSizes'));
      } else if(sizeActiveTab === 'standart') {
        await store.dispatch(submit('presetSizes'));
      } 
    }

    store.dispatch(setViewTab(selectedTab + 1))
  }

  prev = () => {
    const { selectedTab } = this.props
    store.dispatch(setViewTab(selectedTab - 1))
  }

  addToCart = async () => {
    const { data } = await this.props.actions.addToCart();
    setTimeout(() => { this.props.actions.closeCartWidget() }, 5000);

    if (data && data.error_id) {
      this.setState({
        errorMessage: data.error_message,
        errorModalOpened: true,
      });
    }
  }

  render() {

    const {
      selectedTab,
      price,
      showWidget,
      selectedFabric,
      sizes,
      activePreset,
      isMobile,
      setParamsError,
      actions: { closeCartWidget, toggleSetParamsError }
    } = this.props

    let content = null

    switch (selectedTab) {
      case 0:
        content = <BuilderFabric />
        break
      case 1:
        content = <BuilderDetail />
        break
      case 2:
        content = <BuilderSize />
        break
      case 3:
        content = <BuilderProduct />
        break
      default:
        return null
    }

    const settingsFooter = (
      <footer className="b-build-footer">
        <div>
          <button
            className="rit-button rit-button_theme_prev"
            disabled={this.props.selectedTab === 0}
            onClick={this.prev}
          >
            Назад
          </button>
        </div>
        <div className='b-build-footer__price'>
          {price}&#160;
          <RubleIcon size={17} color='currentColor'/>
        </div>
        <div>
          {this.props.selectedTab === 3 ?
            <button 
              className="rit-button rit-button_theme_next"
              disabled={!sizes}
              onClick={this.addToCart}
            >
              В корзину
            </button>
            :
            <button
              className="rit-button rit-button_theme_next rit-button_size_s"
              disabled={this.props.selectedTab === 3}
              onClick={this.next}
            >
              Вперед
            </button>
          }
        </div>
      </footer>
    )

    const widgetValue = Object.values(selectedFabric).length > 0 && Object.values(selectedFabric)[0].displayName;
    const widgetArticle = Object.values(selectedFabric).length > 0 && Object.values(selectedFabric)[0].article;
    return (
      <Fragment>
        <div className="b-settings-wrapper">
          {content}
          {settingsFooter}
        </div>
        <Widget
          show={showWidget}
          price={price}
          fabric={widgetValue}
          type={'builder'}
          isMobile={isMobile}
          onClose={closeCartWidget}
          article={widgetArticle}
          preset={activePreset}
        />
        <CartErrorModal
            title={'Не удалось добавить рубашку в корзину'}
            isOpened={this.state.errorModalOpened}
            onClose={() => this.setState({ errorModalOpened: false, errorMessage: null })}
            closeOnEsc={true}
            errorMessage={this.state.errorMessage}
        />
        <CartErrorModal
            title={' '}
            isOpened={setParamsError}
            onClose={() => toggleSetParamsError(false)}
            closeOnEsc={true}
            errorMessage={(
              <div>К сожалению, невозможно полностью загрузить рубашку из прошлого заказа в новый конструктор.<br/>
                Несуществующие элементы были заменены на стандартные.<br/>
                Просим Вас внимательно проверить выбранные параметры изделия.<br/>
                Параметры рубашек из старых заказов Вы сможете посмотреть в истории заказов.<br/>
                Вы всегда можете связаться с нами любым удобным способом.
              </div>
            )}
        />
      </Fragment>
    );
  }
}

Builder.propTypes = {
  selectedTab: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  showWidget: PropTypes.bool.isRequired,
  selectedFabric: PropTypes.object.isRequired,
  sizes: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  activePreset: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
};


function mapStateToProps(state) {
  return {
    selectedTab: state.ui.selectedTab,
    price: recalculateShirtPrice(state),
    showWidget: isAddedToCart(state),
    selectedFabric: getSelectedFabric(state),
    sizes: getSelectedSize(state),
    activePreset: getActiveDetailsPreset(state),
    isMobile: state.ui.isMobile,
    sizeActiveTab: state.general.updateSize.sizeActiveTab,
    setParamsError: state.ui.setParamsError
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ addToCart, closeCartWidget, screenResize, toggleSetParamsError }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Builder));
